
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/platform",
      function () {
        return require("private-next-pages/platform/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/platform"])
      });
    }
  